var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 h-100 d-flex justify-center align-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"100"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }